// extracted by mini-css-extract-plugin
module.exports = {"list":"Contacts_list__11uDI","item":"Contacts_item__1FV-X","margin":"Contacts_margin__lpQeT"};